import React from 'react';
import ReactTable from 'react-table';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const ReportDataTabs = ({
  tabData,
  tabName,
}) => (
  <div className="c-inner-wrapper c-custom-report-data-tab">
    <h2 className="c-heading u-mb">{tabName}</h2>
    <ReactTable
      className="c-custom-report-data-table"
      showPagination={false}
      minRows={0}
      defaultPageSize={10000}
      NoDataComponent={() => (
        <div className="c-table-no-data">
          No data available
        </div>
      )}
      columns={[
        {
          Header: 'Metric Name',
          id: 'name',
          accessor: item => item,
          Cell: cell => (
            <div className={classnames({ 'u-pl+': cell.value.isBreakdown })}>
              {cell.value.fieldName}
            </div>
          ),
        },
        {
          Header: 'Value',
          id: 'value',
          accessor: item => item.fieldValue,
        },
      ]}
      data={tabData}
    />
  </div>
);

ReportDataTabs.propTypes = {
  tabData: PropTypes.arrayOf(PropTypes.object).isRequired,
  tabName: PropTypes.string.isRequired,
};

export default ReportDataTabs;
